import React from 'react';
import './ServiceHighlight.css';
import { Link } from 'react-router-dom';

const ServiceHighlight = () => {
  return (
    <div className="service-highlight-section container">
      <div className="highlight-text">
        <h2>
          We Always Provide The<br />
          Best Service in Popular Car Spa Services
        </h2>
      </div>

      <div className="highlight-list">
        <h4>Top Car Wash Machine Service</h4>
        <p>Protect More with <Link to="/" className='link-text'>popular car spa services</Link>.</p>
        <p>Shine Longer with top car wash machine service solutions.</p>
        <p>Drive Better with advanced car care technology.</p>
      </div>
    </div>
  );
};

export default ServiceHighlight;